module.exports = __webpack_public_path__ + "static/img/feature2-blue.b516532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature2-blue.png
// module id = FpkB
// module chunks = 0